import type { SceneBuilder } from "../../reel/scenes.js";
import { brandBackdrop } from "../../primitives/brandBackdrop.js";
import {
  accentFor, clipFrame, clipOutroFade, combineSceneFragments, makeTl, typeSize, weights, withAlpha,
  colors as themeColors, escapeHtml, gsapSetLine,
} from "../../reel/sceneShared.js";

export const highlightSweep: SceneBuilder = ({ ctx, clipPrefix, inputs, clipDurationSec, clipStartSec }) => {
  const text = inputs.text ?? "";
  const hi = (inputs.subtext ?? "").trim();
  const accent = accentFor(inputs);
  const hero = typeSize("hero", ctx.format);
  const t = makeTl(clipStartSec);
  const hId = `${clipPrefix}-h`;
  const hlId = `${clipPrefix}-hl`;

  const backdrop = brandBackdrop(ctx, `${clipPrefix}-bg`, { variant: "grid", accent });

  // Replace highlighted word with a marked span
  let inner = escapeHtml(text);
  if (hi) {
    const safeHi = hi.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    inner = escapeHtml(text).replace(new RegExp(safeHi, "i"), (m) =>
      `<span style="display:inline-block;position:relative;padding:0 .15em;color:${themeColors.bg};"><span id="${hlId}" aria-hidden="true" style="position:absolute;inset:0;background:${accent};border-radius:14px;transform-origin:left center;box-shadow:0 8px 24px ${withAlpha(accent, 0.45)};"></span><span style="position:relative;z-index:1;">${m}</span></span>`,
    );
  }

  const html = clipFrame({
    clipPrefix,
    clipStartSec,
    clipDurationSec,
    inner: `<h1 id="${hId}" style="margin:0;font-family:'Outfit',sans-serif;font-weight:${weights.black};font-size:${hero}px;line-height:.95;letter-spacing:-3.5px;color:${themeColors.fg};text-align:center;text-wrap:balance;max-width:${ctx.format === "9:16" ? 940 : 1500}px;">${inner}</h1>`,
  });

  const init = [
    gsapSetLine(`#${hId}`, { opacity: 0, y: 24 }),
    hi ? gsapSetLine(`#${hlId}`, { scaleX: 0 }) : "",
  ].filter(Boolean).join("\n");

  const tweens = [
    t.to(`#${hId}`, { opacity: 1, y: 0, duration: 0.87, ease: "raw:\"power2.out\"" }, 0),
  ];
  if (hi) tweens.push(t.to(`#${hlId}`, { scaleX: 1, duration: 0.6, ease: "raw:\"back.out(1.4)\"" }, 18 / 30));
  tweens.push(clipOutroFade(clipPrefix, clipDurationSec, clipStartSec));

  return combineSceneFragments([backdrop, { html, init, tweens }]);
};
